import { useTranslation } from 'react-i18next';

import { extractFirstNumber } from '@/components/AdvertisePayments/AdvertisePayments.helpers';
import {
  PaidOption,
  ServicePeriodItem
} from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';

export const useMapServicePeriodItems = () => {
  const { t } = useTranslation();

  const mapTimes = (paidOptions: PaidOption[]): ServicePeriodItem[] =>
    paidOptions.map(option => {
      const numberValue =
        extractFirstNumber(option.id) || extractFirstNumber(option.name);
      return {
        id: numberValue,
        count: t('Advertise.plural.times', { count: numberValue }),
        periodTime: t('Advertise.plural.every_24_hours'),
        price: `${option.price} ₼`
      };
    });

  const mapDays = (paidOptions: PaidOption[]): ServicePeriodItem[] =>
    paidOptions.map(option => {
      const numberValue =
        extractFirstNumber(option.id) || extractFirstNumber(option.name);
      return {
        id: numberValue,
        count: t('Advertise.plural.days', { count: numberValue }),
        periodTime: '',
        price: `${option.price} ₼`
      };
    });

  return { mapTimes, mapDays };
};
